<template>
    <div class="indicator-container">
        <ListHeader :title="data.name || '三级维度指标'">
            <template slot="right">
                <ActionButton2 :on-click="handleActionClick" />
            </template>
        </ListHeader>
        <div class="indicator-content">
            <div class="score-box">
                <Score :score="data.score || 0" :maxScore="data.maxScore || 0" />
            </div>
            <div class="divider"></div>
            <div class="text-box">
                {{ data.remark || '暂无描述内容' }}
            </div>
            <div class="divider"></div>
            <div class="chart-box">
                <EvidenceChart :gain="data.gainList" :loss="data.lossList" height="180px"></EvidenceChart>
            </div>
        </div>
    </div>
</template>
<script>
import ListHeader from '@/components/ListHeader.vue';
import Score from './Score.vue';
import ActionButton2 from './ActionButton2.vue';
import EvidenceChart from './EvidenceChart.vue';

export default {
    name: 'ReportStyle4',
    components: {
        ListHeader,
        Score,
        ActionButton2,
        EvidenceChart,
    },
    props: {
        data: {
            type: Object,
            default: null
        },
        onClick: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
        };
    },

    mounted() {
        window.addEventListener('resize', this.resizeChart);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeChart);
    },
    methods: {
        // 处理ActionButton2组件的点击事件，传递数据和类型
        handleActionClick(type) {
            if (this.onClick) {
                this.onClick(type, this.data);
            } else {
                console.log(`在ReportStyle4中点击了${type}按钮`);
            }
        },

        resizeChart() {
        }
    }
}
</script>
<style lang="less" scoped>
// 引入通用指标样式
@import '@/assets/css/common-indicator.less';

.indicator-container {
    .indicator-content {


        .text-box {
            width: 400px;

        }

        .chart-container {
            .line-chart {
                width: 100%;
                height: 100%;
            }
        }

    }
}
</style>
